var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"text-xs-center":""}},[_c('userDebug'),_c('v-card',[_c('v-card-title',[_vm._v("Custom Artist Dashboard")]),_c('v-card-text',[_vm._v(" Welcome to your dashboard. Here you can manage your artworks and products ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }